module.exports = __webpack_public_path__ + "de3be92cf54474acbdecc099f549be8b.MP3";